module.exports = __webpack_public_path__ + "img/acacia_mweya22.c2d44e89.jpg";